import styled from "styled-components";

export const Footer = styled.footer`
  background: #1a3b75;
  height: 100px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: auto;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.15);
`;

export const FooterText = styled.span`
  color: #dae4f5;
  font-size: 0.8rem;
`;
